import Swiper from "swiper";
// 1. Import Autoplay here
import { Navigation, EffectFade, Autoplay } from "swiper/modules";

// Import styles
import "swiper/css";
import "swiper/css/effect-fade";

export const initEminogluHero = (): void => {
  const container = document.querySelector<HTMLElement>(".eminoglu-hero");
  if (!container) return;

  const imageSwiperElement = container.querySelector<HTMLElement>(
    ".eminoglu-hero__image-swiper",
  );
  const textSwiperElement = container.querySelector<HTMLElement>(
    ".eminoglu-hero__text-swiper",
  );

  if (!imageSwiperElement || !textSwiperElement) return;

  // 1. Initialize Text Swiper (Fade Effect, No Navigation)
  const textSwiper = new Swiper(textSwiperElement, {
    modules: [EffectFade],
    effect: "fade",
    fadeEffect: { crossFade: true },
    allowTouchMove: false,
    loop: true,
    speed: 800,
  });

  // 2. Initialize Image Swiper (Slide Effect, Handles Navigation & Autoplay)
  const imageSwiper = new Swiper(imageSwiperElement, {
    // 2. Add Autoplay to the modules array
    modules: [Navigation, Autoplay],
    slidesPerView: "auto",
    spaceBetween: 30,
    centeredSlides: false,
    loop: true,
    grabCursor: true,
    watchSlidesProgress: true,
    speed: 800,

    // 3. Add the autoplay configuration
    autoplay: {
      delay: 5000, // 5 seconds per slide
      disableOnInteraction: false, // Keep autoplaying even if the user clicks/swipes
    },

    navigation: {
      nextEl: ".eminoglu-hero__nav-btn--next",
      prevEl: ".eminoglu-hero__nav-btn--prev",
    },
    breakpoints: {
      250: {
        spaceBetween: 20,
      },
      768: {
        spaceBetween: 30,
      },
      1024: {
        spaceBetween: 30,
      },
      1280: {
        spaceBetween: 40,
      },
      1600: {
        spaceBetween: 50,
      },
    },
  });

  // 3. Bulletproof Synchronization
  imageSwiper.on("slideChange", () => {
    if (textSwiper.realIndex !== imageSwiper.realIndex) {
      textSwiper.slideToLoop(imageSwiper.realIndex);
    }
  });

  console.log("[EminogluHero] Synchronized Sliders initialized with Autoplay.");
};
